export default __webpack_public_path__ + "static/media/srisailamVisitOne.c8fddfb0.jpg";